import {Component} from '@angular/core';

import { MenuItemType} from '@models/i-menu-item';
import {MENU_ITEMS} from '@shared/config/menu';

@Component({
  selector: '',
  template: '',
})
export abstract class SummaryParent {
  readonly MENU_ITEMS = MENU_ITEMS;
  readonly MenuItemType = MenuItemType
}
